import React from "react"

export const withSizeGuide = Component => ({ name = "SizeGuide", page }) => {
  const { title, content, tabs } = page || {}

  Component.displayName = name
  return <Component title={title} content={content} tabs={tabs} />
}
